import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import TopBar from "../components/TopBar";

const OutLook = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (mobile) setIsSidebarOpen(false);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="min-h-screen bg-neutral-50">
      <Sidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} isMobile={isMobile} />

      <div className={`flex flex-col min-h-screen transition-all duration-300 ${isMobile ? '' : isSidebarOpen ? 'pl-72' : 'pl-20'} print:pl-0`}>
        <TopBar onMenuClick={toggleSidebar} isSidebarOpen={isSidebarOpen} isMobile={isMobile} />

        <main className="flex-1 mt-16 w-full print:mt-0">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 print:px-0 print:py-0 print:max-w-none">
            <div className="bg-white rounded-xl shadow-sm border border-neutral-200 overflow-hidden print:shadow-none print:border-0 print:rounded-none">
              <div className="p-6 sm:p-8 print:p-0">
                <Outlet />
              </div>
            </div>

            <footer className="mt-8 py-6 border-t border-neutral-200 print:hidden">
              <div className="flex flex-col sm:flex-row items-center justify-between text-sm text-neutral-600">
                <span className="text-center sm:text-left">
                  Copyright &copy; {new Date().getFullYear()}.{" "}
                  <a href="https://www.samtec.ng/" target="_blank" rel="noreferrer" className="text-primary-600 hover:text-primary-700 font-medium transition-colors">
                    Samtec & Associate Nigeria Limited
                  </a>
                </span>
                <span className="mt-2 sm:mt-0 text-neutral-500">
                  ATBCOE Kangere Student Portal
                </span>
              </div>
            </footer>
          </div>
        </main>
      </div>
    </div>
  );
};

export default OutLook;
